import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250620075950/app/[lng]/components/(MiniWebsite)/profile/ProfileSection.tsx");
